export default __webpack_public_path__ + "img/img_maivo-fc89481878f741bdf4a63767bd8259fb.jpg";